export const STATUS_OPEN = 'Open';
export const STATUS_REQUESTED = 'Requested';
export const STATUS_CONFIRMED = 'Confirmed';
export const STATUS_PARTIALLY_CONFIRMED = 'Partially Confirmed';
export const STATUS_CANCELLED = 'Cancelled';
export const STATUS_EXPIRED = 'Expired';
export const MEDICAL_ESCORT = 'Medical Escort';
export const OTHERS = 'Others';
export const OTHER_FUNDING = 'Other Funding';
export const OTHER_FUNDING_TAX_FREE = 'Other Funding - Tax free';
export const COMPANIONSHIP = 'Companionship';
export const PHYSIOTHERAPY = 'Physiotherapy';
export const SPEECH_THERAPY = 'Speech Therapy';
export const OCCUPATIONAL_THERAPY = 'Occupational Therapy';
export const BASIC_CONSULTATION = 'Basic Consultation';
export const MEAL_ARRANGEMENT = 'Meal Arrangement';

export const MAX_CPS_FOR_VISIT = 20;

export const FLEXIBLE_VISIT_TIMING = ['Yes', 'No', 'Not Sure'];

export const MOBILITY_TYPES = [
  'Level A: Independent',
  'Level B: Mild Assistance',
  'Level C: Moderate Assistance',
  'Level D: Maximum Assistance',
  'Level E: Fully Dependent',
];

export const NURSE_REQUIREMENTS = ['Nurse Not Required', 'Nurse Requested', 'Nurse Required'];

export const BED_TYPES = [
  'Low Bed (<65cm)',
  'Standard Bed (~65cm)',
  'High Bed (>65cm)',
  'Hospital Bed (adjustable)',
  'Mattress Only (floor level)',
];

export const TRANSFER_TYPES = [
  {
    name: 'Standing Transfer',
    unselected_image_url:
      'https://testing-sg-api.smiley-unicorn.info/images/api/mobility/transfer_type/standing_transfer_unselected.png',
  },
  {
    name: 'Pivot Transfer',
    unselected_image_url:
      'https://testing-sg-api.smiley-unicorn.info/images/api/mobility/transfer_type/pivot_transfer_unselected.png',
  },
  {
    name: 'Manual Lifting',
    unselected_image_url:
      'https://testing-sg-api.smiley-unicorn.info/images/api/mobility/transfer_type/manual_lifting_unselected.png',
  },
  {
    name: 'Two-man Transfer',
    unselected_image_url:
      'https://testing-sg-api.smiley-unicorn.info/images/api/mobility/transfer_type/two-man_transfer_unselected.png',
  },
];

export const VISIT_BREAK_OPTIONS = ['No break', '0.5 hour', '1 hour'];

export const VISIT_SOURCE_OPTIONS = [{name: 'Call'}, {name: 'Email'}, {name: 'Mobile', type: 'disabled'}];

export const B2B_VISIT_SOURCE_OPTIONS = [
  {name: 'Webform in-app', type: 'disabled'},
  {name: 'Webform desktop', type: 'disabled'},
  {name: 'Typeform'},
  {name: 'Whatsapp'},
  {name: 'Email'},
  {name: 'Call'},
];

export const VISIT_SOURCE_DISABLED = ['Mobile', 'Webform in-app', 'Webform desktop'];

export const SURCHARGE_WAIVE_REASONS = ['B2B Visits', 'Others'];
export const SURCHARGE_DONOT_PAY_REASONS = ['Urgent surcharge was waived', 'Others'];

export const PAY_IN_APP_REASONS = [
  'Does not own a mobile phone',
  'Not a tech savvy person',
  'Does not understand English',
  'Others',
];

export const visit_schedule = 'visit_schedule',
  created_by = 'created_by',
  customer_requested_at = 'customer_requested_at',
  visit_location_address = 'visit_location_address',
  requested_services = 'requested_services',
  medical_conditions = 'medical_conditions',
  meal_requirements = 'meal_requirements',
  nursing_procedure = 'nursing_procedure',
  home_rehabilitation = 'home_rehabilitation',
  home_medical_details = 'home_medical_details',
  companionship_description = 'companionship_description',
  procedures = 'procedures',
  current_symptoms = 'current_symptoms',
  current_symptoms_details = 'current_symptoms_details',
  currently_on_medication = 'currently_on_medication',
  medication_details = 'medication_details',
  have_drug_allergy = 'have_drug_allergy',
  drug_allergy_details = 'drug_allergy_details',
  therapy_details = 'therapy_details',
  doctor_memo_available = 'doctor_memo_available',
  doctor_memo = 'doctor_memo',
  expected_outcome = 'expected_outcome',
  medical_escort_details = 'medical_escort_details',
  name = 'name',
  phone = 'phone',
  is_medical_appointment = 'is_medical_appointment',
  medical_appointment_location = 'medical_appointment_location',
  medical_appointment_time = 'medical_appointment_time',
  medical_appointment_detail = 'medical_appointment_detail',
  is_providing_transportation = 'is_providing_transportation',
  transportation_details = 'transportation_details',
  home_medical = 'home_medical',
  ambulant = 'ambulant',
  is_nurse_required = 'is_nurse_required',
  is_nurse_requested = 'is_nurse_requested',
  reason_for_nurse = 'reason_for_nurse',
  mobility_instruction = 'mobility_instruction',
  has_manual_transfer = 'has_manual_transfer',
  manual_transfer_help = 'manual_transfer_help',
  have_hoist = 'have_hoist',
  co_accept_2_cps = 'co_accept_2_cps',
  manual_transfer_help_details = 'manual_transfer_help_details',
  transfer_points = 'transfer_points',
  bed = 'bed',
  breaks = 'breaks',
  required_cp = 'required_cp',
  transfer_type = 'transfer_type',
  require_vital_sign = 'require_vital_sign',
  special_requests_instructions = 'special_requests_instructions',
  internal_ops_cr_note = 'internal_ops_cr_note',
  internal_ops_fulfillment_note = 'internal_ops_fulfillment_note',
  preferred_cps = 'preferred_cps',
  customer_request_origin = 'customer_request_origin',
  assigned_carepros = 'assigned_carepros',
  payment_breakdown = 'payment_breakdown',
  blob_urls = '_blobUrls',
  preferred_cps_list_by_service = 'preferred_cps_list_by_service',
  preferred_cps_option = 'preferred_cps_option',
  hard_soft_value_designation = 'hard_soft_value_designation',
  co_preferred_timing_obj = 'co_preferred_timing_obj';

export const APP_COUNTRY = process.env.REACT_APP_COUNTRY || 'Singapore';
export const isSG = APP_COUNTRY === 'Singapore';
export const isMY = APP_COUNTRY === 'Malaysia';
export const isAU = APP_COUNTRY === 'Australia';
export const APP_COUNTRY_CODE = isSG ? 'sg' : isMY ? 'my' : 'au';
export const APP_PHONE_CODE = isSG ? '+65' : isMY ? '+60' : '+61';
export const APP_TYPE = process.env.REACT_APP_TYPE || 'B2C';
export const isAppTypeB2B = APP_TYPE === 'B2B';
export const isAppTypeB2C = APP_TYPE === 'B2C';

// Remember to update this list when we launch in new City
export const AU_CITIES = [
  {name: 'Melbourne', id: 'RqLvjBS6L'},
  {name: 'Sydney', id: '7ebXqJmuw37sAs7ow'},
  {name: 'Brisbane', id: 'pPXBRu4JyomEgZbK5'},
  {name: 'Perth', id: '6GhkjhJp6ABDRsNjw'},
  {name: 'Adelaide', id: 'fCQHauHxsx85owwcq'},
];

export const STC_SHOW_ON_FE = [
  {name: 'Showing', _id: 'yes'},
  {name: 'Not Showing', _id: 'no'},
];


export const CP_SIGNUP_ATTRIBUTES = {
  engagement_types: [
    {
      name: 'fl',
      value: 'Freelance',
    },
    {
      name: 'stc',
      value: 'Short-Term Contract',
    },
    {
      name: 'ft',
      value: 'Full-Time',
    },
  ],
  job_opportunities: [
    {
      name: 'hc',
      value: 'Home Care',
    },
    {
      name: 'fbc',
      value: 'Facility-Based Care',
    },
    {
      name: 'covid',
      value: 'Covid Assignments',
    },
    {
      name: 'ics',
      value: 'Interim Care Services',
    },
  ],
  role_types: [
    {
      name: 'rn',
      value: 'Registered Nurse',
    },
    {
      name: 'en',
      value: 'Enrolled Nurse',
    },
    {
      name: 'pca',
      value: 'Patient Care/Healthcare Assistant',
    },
    {
      name: 'ta',
      value: 'Therapy Assistant',
    },
    {
      name: 'pt',
      value: 'Therapist - Physio',
    },
    {
      name: 'st',
      value: 'Therapist - Speech',
    },
    {
      name: 'op',
      value: 'Therapist - Occupational',
    },
    {
      name: 'dr',
      value: 'Doctor',
    },
  ],
};
